import { createDynamicMiddleware } from '@reduxjs/toolkit';

// Lets route-only slices and RTK Query APIs join the store when their chunk first loads, so they
// stay out of the main bundle (AB#2926). Modules register themselves at evaluation time, which
// always happens before any component in that chunk renders or dispatches.
export const dynamicMiddleware = createDynamicMiddleware();

const lazyReducers = {};
let onReducersChanged = null;

export const getLazyReducers = () => lazyReducers;

// store.js subscribes here; registrations made before the store exists are picked up on creation.
export const setLazyReducersListener = (listener) => {
  onReducersChanged = listener;
};

export const registerLazyReducer = (key, reducer) => {
  if (lazyReducers[key] === reducer) {
    return;
  }
  lazyReducers[key] = reducer;
  onReducersChanged?.();
};

export const registerLazyApi = (api) => {
  // Middleware first so it is in place before any query from this chunk can dispatch.
  dynamicMiddleware.addMiddleware(api.middleware);
  registerLazyReducer(api.reducerPath, api.reducer);
};
